import { useAsyncDataRequestStatus } from '@/wabunka-src/common';
import { useMicroCMSGetListDetail } from '@/wabunka-src/common/composables/query/useMicroCMSClient';
import { createDefaultFeaturedState, type FeaturedViewModel } from '@/wabunka-src/common/features';
import type { microCMSDraftKeyQuery } from '@/wabunka-src/common/models/microCMS';

import type { AsyncDataRequestStatus } from 'nuxt/app';

/**
 * pathとqueryからdedupe用のkeyの組み立てを行う
 * TODO 他のuseFetch使っている箇所と共通化したい
 */
const buildKey = (path: string, query?: object, server?: boolean) => {
  return path + (query ? ',query=' + JSON.stringify(query) : '') + (server ? ',server' : ',client');
};

const ITINERARY_TYPE = 'itinerary';

/** itinerary の取得に使用する Composable（Page でのみ使用可能）。itinerary 以外は draftKey 付きのプレビューでのみ返す（JCAT-5900） */
export const useGetItineraryQuery = async (contentId: string, draftKeyQuery: microCMSDraftKeyQuery, server: boolean = false, hasDraftKey: boolean) => {
  const { data, status }: { data: Ref<FeaturedViewModel | null>; status: Ref<AsyncDataRequestStatus> } = await useMicroCMSGetListDetail<FeaturedViewModel>(
    {
      endpoint: 'en-featured',
      contentId: contentId,
      queries: { ...draftKeyQuery },
    },
    {
      key: buildKey('en-featured', { contentId, ...draftKeyQuery }, server),
      server: server,
    },
  );

  const requestStatus = useAsyncDataRequestStatus(status);

  // 詳細取得 API では filters が効かないため、取得結果の type で判定する（sitemap 生成側と同じく includes で見る）
  const isItinerary = computed<boolean>(() => (data.value?.type ?? []).includes(ITINERARY_TYPE));

  // draftKey ありは CMS のプレビューなので type を問わず表示する
  const enItinerary = computed<FeaturedViewModel>(() => (data.value && (isItinerary.value || hasDraftKey) ? data.value : createDefaultFeaturedState()));

  /** 取得に失敗した、コンテンツが無い、または itinerary 以外を draftKey 無しで開いた */
  const isNotFound = computed<boolean>(() => requestStatus.hasError.value || data.value === null || (!isItinerary.value && !hasDraftKey));

  return { enItinerary, isNotFound, ...requestStatus };
};
